import React, { createContext, useState,useContext } from 'react';
import { toast } from 'react-toastify';
import { TokenContext } from './TokenContext';

import { apiPGM } from '../services/api';
// import TipoFilial from '../assets/styles/payloadsFilial/payloadFilial.json';

export const FilialContext = createContext([]);

export function FilialProvider(props) {
	const { children, user } = props;

	const [dataFiliais, setDataFiliais] = useState([]);
	const [totalFilial, setTotalFilial] = useState(0);
	const [montante, setMontante] = useState('');
	const [loadingFilial, setLoadingFilial] = useState(true);

	const { autenticacaoV1Token } = useContext(TokenContext);
	async function authToken() {
		let result = null;
		try {
			result = await autenticacaoV1Token();
		} catch (e) {
			console.error(e);
		}
		return result;
	}
	

	async function getFiliais(pagina = 1) {
		try {
			setLoadingFilial(false)
			const response = await apiPGM.get(`/resumo/filiais`,
				{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${user.token.access}`,
					},
					params: {page: pagina}
				}).then(res => {
					setLoadingFilial(true)
					setMontante(res.data.montante)
					setDataFiliais(res.data.dados)
					setTotalFilial(res.data.total_registros)
				});

			return response;
		} catch (error) {
			setLoadingFilial(true)
			let msg = 'Filiais não carregadas. Por favor atualize a página.'
			
			if(error.response.data.message){
				msg = error.response.data.message;
			}

			toast.error(msg);
		}
		return null;
	}

	return (
		<FilialContext.Provider
			value={{
				authToken,
				getFiliais,
				dataFiliais,
				montante,
				totalFilial,
				loadingFilial,
				// getExport
			}}>
			{children}
		</FilialContext.Provider>
	);
}
